var LocalizationKeysObject = {
  confirmNewPassword: {
    id: 'confirmNewPassword',
    defaultMessage: 'Confirm new password'
  },
  confirmNewPasswordDoesNotMatch: {
    id: 'confirmNewPasswordDoesNotMatch',
    defaultMessage: "Confirm password doesn't match."
  },
  connect: {
    id: 'connect',
    defaultMessage: 'Connect'
  },
  connectToYourAccount: {
    id: 'connectToYourAccount',
    defaultMessage: 'Connect to your account'
  },
  continue: {
    id: 'continue',
    defaultMessage: 'Continue'
  },
  emailAddressOrRegistrationNumber: {
    id: 'emailAddressOrRegistrationNumber',
    defaultMessage: 'Email address or registration number'
  },
  enterEmailOrBrandPartnerNumber: {
    id: 'enterEmailOrBrandPartnerNumber',
    defaultMessage: 'Enter email or brand partner number'
  },
  enterPassword: {
    id: 'enterPassword',
    defaultMessage: 'Enter password'
  },
  errorWhenSettingUpPassword: {
    id: 'errorWhenSettingUpPassword',
    defaultMessage: 'Error when setting up password'
  },
  facebookContinueWith: {
    id: 'facebookContinueWith',
    defaultMessage: 'Continue with Facebook'
  },
  failedToSubmit: {
    id: 'failedToSubmit',
    defaultMessage: 'Failed To Submit'
  },
  forgotPassword: {
    id: 'forgotPassword',
    defaultMessage: 'Forgot password?'
  },
  forgottenPassword: {
    id: 'forgottenPassword',
    defaultMessage: 'Forgotten password'
  },
  forgotYourPasswordQuestion: {
    id: 'forgotYourPasswordQuestion',
    defaultMessage: 'Forgot your password? Type in the e-mail address you used when you registered or consultant number and we will send your details.'
  },
  googleAccountContinueWith: {
    id: 'googleAccountContinueWith',
    defaultMessage: 'Continue with Google Account'
  },
  iAlreadyHaveATempPassword: {
    id: 'iAlreadyHaveATempPassword',
    defaultMessage: 'I already have a temporary password'
  },
  invalidCredentials: {
    id: 'invalidCredentials',
    defaultMessage: 'Invalid username or password'
  },
  loading: {
    id: 'loading',
    defaultMessage: 'Loading'
  },
  logIn: {
    id: 'logIn',
    defaultMessage: 'Log in'
  },
  newPassword: {
    id: 'newPassword',
    defaultMessage: 'New password'
  },
  notABrandPartnerYet: {
    id: 'notABrandPartnerYet',
    defaultMessage: 'Not a brand partner yet'
  },
  orisalesLogin: {
    id: 'orisalesLogin',
    defaultMessage: 'Orisales Login'
  },
  password: {
    id: 'password',
    defaultMessage: 'Password'
  },
  register: {
    id: 'register',
    defaultMessage: 'Register'
  },
  signIn: {
    id: 'signIn',
    defaultMessage: 'Sign in'
  },
  temporaryPassword: {
    id: 'temporaryPassword',
    defaultMessage: 'Temporary password'
  },
  theFirstTimeYouLogIn: {
    id: 'theFirstTimeYouLogIn',
    defaultMessage: "The first time you log in with {SocialNetwork}, you'll need to connect your {SocialNetwork} account to your Oriflame account."
  },
  vKontakteContinueWith: {
    id: 'vKontakteContinueWith',
    defaultMessage: 'Continue with VKontakte'
  },
  weChatContinueWith: {
    id: 'weChatContinueWith',
    defaultMessage: 'Continue with Wechat'
  },
  appleContinueWith: {
    id: 'appleContinueWith',
    defaultMessage: 'Continue with Apple'
  },
  passwordRequirementLetter: {
    id: 'passwordRequirementLetter',
    defaultMessage: 'Letters'
  },
  passwordRequirementCharactersCount: {
    id: 'passwordRequirementCharactersCount',
    defaultMessage: '{0}+ characters'
  },
  passwordRequirementDigit: {
    id: 'passwordRequirementDigit',
    defaultMessage: 'Numbers'
  },
  passwordRequirementLowerCaseLetter: {
    id: 'passwordRequirementLowerCaseLetter',
    defaultMessage: 'Lower case letters'
  },
  passwordRequirementUpperCaseLetter: {
    id: 'passwordRequirementUpperCaseLetter',
    defaultMessage: 'Upper case letters'
  },
  passwordRequirementSpecialCharacter: {
    id: 'passwordRequirementSpecialCharacter',
    defaultMessage: 'Special characters'
  },
  joinOriflame: {
    id: 'joinOriflame',
    defaultMessage: 'Join Oriflame'
  },
  errorOccured: {
    id: 'errorOccured',
    defaultMessage: 'An error occured'
  },
  emptyMandatoryProperty: {
    id: 'emptyMandatoryProperty',
    defaultMessage: 'Mandatory value is missing'
  },
  disabledDuringMaintenance: {
    id: 'disabledDuringMaintenance',
    defaultMessage: 'Login is disabled due to system maintenance'
  },
  blockedForLoginUser: {
    id: 'blockedForLoginUser',
    defaultMessage: 'You do not have access'
  },
  invalidPropertyLength: {
    id: 'invalidPropertyLength',
    defaultMessage: 'Value has wrong length'
  },
  invalidPropertyFormat: {
    id: 'invalidPropertyFormat',
    defaultMessage: 'Value has wrong format'
  },
  customerNotFound: {
    id: 'customerNotFound',
    defaultMessage: 'Customer not found'
  },
  phoneNotFound: {
    id: 'phoneNotFound',
    defaultMessage: 'Phone number not found'
  },
  emailNotFound: {
    id: 'emailNotFound',
    defaultMessage: 'Email not found'
  },
  emptyMandatoryEmailAndPhone: {
    id: 'emptyMandatoryEmailAndPhone',
    defaultMessage: 'Please fill in your email and phone number'
  },
  customerHasInactiveAccount: {
    id: 'customerHasInactiveAccount',
    defaultMessage: 'Customer account is no longer active'
  },
  terminatedOrNotExistingCustomer: {
    id: 'terminatedOrNotExistingCustomer',
    defaultMessage: 'Customer not found'
  },
  emptyMandatoryNotificationChannel: {
    id: 'emptyMandatoryNotificationChannel',
    defaultMessage: 'Please fill in the notification channel'
  },
  externalAccountAlreadyConnected: {
    id: 'emptyMandatoryNotificationChannel',
    defaultMessage: 'Already signed-in'
  },
  invalidPassword: {
    id: 'invalidPassword',
    defaultMessage: 'Invalid password'
  },
  invalidPasswordFormat: {
    id: 'invalidPasswordFormat',
    defaultMessage: 'Password has wrong format'
  },
  invalidResetToken: {
    id: 'invalidResetToken',
    defaultMessage: 'Reset token is not valid'
  },
  accountLockedDueToMultipleInvalidLogin: {
    id: 'accountLockedDueToMultipleInvalidLogin',
    defaultMessage: 'Account locked - please come back later'
  }
};
export var LocalizationKeys = LocalizationKeysObject;